// src/services/leadService.ts

import axiosInstance from 'services/common/axiosInstance';

export interface Lead {
  id: number;
  service_name: string;
  contact_name: string;
  email_id: string;
  country_code: string;
  dial_code: string;
  phone_no: string;
  status: string;
  note: string;
  createdon: string;
  updatedon: string;
  updatedby: string | null;
}

export interface Pagination {
  page: number;
  per_page: number;
  total_pages: number;
  total_items: number;
}

export interface LeadListResponse {
  message: string;
  data: {
    leads: Lead[];
    pagination: Pagination;
  };
  success: boolean;
}

export interface UpdateLeadResponse {
  message: string;
  data: number;
  success: boolean;
}

export interface GetLeadListParams {
  page: number;
  per_page: number;
  from_date: string;
  to_date: string;
  status: string;
  lead_id: number;
}

export interface UpdateLeadParams {
  status: string;
  note: string;
}

export const fetchLeadListApi = async (
  data: GetLeadListParams
): Promise<LeadListResponse> => {
  try {
    const response = await axiosInstance.post('/lead/listleads', data);
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};

export const updateLeadApi = async (
  lead_id: number,
  data: UpdateLeadParams
): Promise<UpdateLeadResponse> => {
  try {
    const response = await axiosInstance.put(
      `/lead/updatelead?lead_id=${lead_id}`,
      data
    );
    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};
